/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import Pagination from '../../../components/Pagination';
import 'tw-elements';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../../components/ConfirmationPrompt';
import AnimatedModel from '../../../components/Animation/AnimatedModel';
import { dataService } from '../../../services/data.services';
import GlobalContext from '../../../components/Context/GloablContext';
import Table from './components/Table';
import TopBar from '../../../components/TopBar';
import EmptyScreenBranch from './components/EmptyScreen';
import { BranchUser } from './BranchUserSlice';
import ViewBranchUser from './ViewBranchUser';
import { STAGE } from '../../../config';
import { AllRolesList } from '../../ManageInstitutionUsers/roles';

const ManageBranchUserList = ({id, branchName, loading, setLoading, BranchDisabled}) => {
    const { setToastErrorMessage, setToastmessage,toastErrorMessage } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const BranchUserList = useSelector(state => state.BranchUserSlice);
    const { List} = BranchUserList
    const [loadingActivation, setLoadingActivation] = useState(false);
    const [addOpen, setAddOpen] = useState(false)
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [searchParams, setSearchParams] = useSearchParams({ page_number:  1 });
    const [email, setemail] = useState('')
    const [loadingPage,setLoadingPage]=useState(false)
    const initialInputValue = {
        admin_first_name : '',
        admin_last_name: '',
        admin_email_address: '',
        admin_mobile_number:'',
        roles:[]
    }
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [inputValue, setInputValue] = useState(initialInputValue);
    const [fistLoading, setFirstLoading] = useState(false)
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [selectedbranchUserEmail, setSelectedBranchUserEmail] = useState('');
    const [branchUserData, setbranchUserData] = useState({})
    const [listOfRoles, setListOfRoles] = useState({});
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const placeholderOptions = [
        'Employee Number',
        'Full Name',
        'Email Address',
        'Mobile Number'
    ];

    
    /* The below code is using the `useEffect` hook in React to set up an interval that changes the
    placeholder index cyclically every 2 seconds. The `setPlaceholderIndex` function is used to update
    the state of the placeholder index based on the previous index value and the length of the
    `placeholderOptions` array. The interval is cleared when the component unmounts to prevent memory
    leaks. */
    useEffect(() => {
        const interval = setInterval(() => {
            // Change placeholder index cyclically
            setPlaceholderIndex(prevIndex => (prevIndex + 1) % placeholderOptions.length);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    const getSelectedRoleList = async (item) => {
        setLoadingPage(true)
        const response = await dataService.GetAPI(`users/${item}`);
        if (response.data.status===200) {   
            setbranchUserData(response?.data?.data?.data)
            setLoadingPage(false);
        }else {
            setLoadingPage(false);

        }
        
        {
            const filteredRoles = Object.entries(AllRolesList).map(([item, subitems]) => {
                const filteredSubitems = subitems.filter(subitem => {
                    // Define key mappings for special cases
                    const key = item === "Employees" && subitem === "Directory " ? 'employee-directory' :item === "Students-Activity" && subitem === "Directory" ? 'directory' : item === "Employees" && subitem === "Attendance" ? 'employees-attendance' :
                        item === "Students-Activity" && subitem === "Attendance" ? 'students-attendance' :
                            item === "Students-Activity" && subitem === "Academic Reports" ? 'academic-reports' :
                                subitem.toLowerCase().replace(/\s/g, '-'); // Default mapping
                    if (item === "Students-Fee" && subitem === "Collect Fee:Receipt") {
                        const anyCollectFeeRoleExists = response?.data?.data?.data?.roles.some(role => role.startsWith("collect-fee:"));
                        return (response?.data?.data?.data?.roles.includes("collect-fee") && !anyCollectFeeRoleExists || 
                                response?.data?.data?.data?.roles.includes("collect-fee") && response?.data?.data?.data?.roles.includes("collect-fee:receipt"));
                    }
                    return (response?.data?.data?.data?.roles).includes(key);
                });

                return filteredSubitems?.length > 0 ? { [item]: filteredSubitems } : null;
            }).filter(Boolean);
            setListOfRoles(filteredRoles);

        } 
        
    };

    // useEffect(() => {
    //     getSelectedRoleList();
    // }, [selectedbranchUserEmail])
    

    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setLoading(true);
        setSearchParams({ page_number:  1 })
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getBranch = useCallback(async () => {
        try {
            let params = Object.fromEntries(searchParams);
            delete params?.tab
            const payload = new URLSearchParams(params).toString();
            dispatch(BranchUser(`users?user_type=branch-user&branch_id=${id.split('*')[0]}&${(payload)}`)).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response?.payload?.data.data.total_count === 0 && response.payload.data.data.data?.length === 0 && searchParams.get('search')===null && searchParams.get('filter') === null ) {
                        setFirstLoading(true);
                    } else {
                        setFirstLoading(false);
                        setEmptyScreenMessage("We couldn't find anything that matched your search")
                    }
                    if(Math.ceil(response?.payload?.data?.data.totat_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.totat_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("We couldn't find anything that matched your search")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
            // setsearchFieldDebounce(searchParams.get('search') !== null ? searchParams.get('search') : '')
        } catch (error) {
            handleLoadData()
        }
    }, [location]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    /* `useEffect(() => { getBranch(); }, [getBranch]);` is a hook that is used to run
    the `getBranch` function whenever the `getBranch` function changes. In this case,
    the `getBranch` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getBranch` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        getBranch();
    }, [getBranch]);

    /**
     * This function handles the click event for a side popup by resetting an input value and toggling
     * the state of a boolean variable.
     */
    const handleSidePopupClick = (type, item) => {
        if(type === 'Edit') {
            setInputValue({
                admin_first_name : item.first_name,
                admin_last_name: item.last_name,
                admin_email_address: item.email_address,
                admin_mobile_number: item.mobile_number,
                roles: item.roles
            })
        } 
        if(type === 'View') {
            getSelectedRoleList(item)
            setOpenViewPopup(true)
            // selectedbranchUserEmail(item)
        }
        else {
            setInputValue(initialInputValue)
        }
        // setAddOpen(!addOpen);
    }
    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        setLoadingActivation(true);
        try {
            let body = { }
            if(confirmationState.status !== "Reset Password") {
                body = {
                    "status": confirmationState.status === 'Activate' ? true : false             
                }
            }
            let endpoint= confirmationState.status==="Reset Password"?`users/reset-password/${confirmationState.item.email_address}`:`users/${confirmationState.item.email_address}`
            if(confirmationState.status==="Reset Password"){
                body={
                    reset:true
                }
            }else{
                body={
                    "status":confirmationState.status==='Deactivate'?false:true
                }
            }
            const response = await dataService.PatchAPI(body,endpoint);
            const state=confirmationState.status==='Deactivate'?'deactivated':'activated'
            setLoadingActivation(false);
            if(confirmationState.status === 'Reset Password'){
                setToastmessage('Reset password email sent successfully')
            } else{
                setToastmessage(`Branch User ${state} successfully`);
            }
            handleConformationClick();
            setLoading(true)
            getBranch();
        } catch (error) {
            handleConformationClick();
            setLoadingActivation(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }

    const handleFilters = (key, value) => {
        setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params.filter = true
        if(key === 'all'){
            delete params['filter'];
            delete params['status'];
        } 
        else params[key] = value === "active" ? true : value === "inactive" ? false : value
        setSearchParams({ ...params})
    }
  
    return (
        <>
            <div class="scroll-bar tabbedPgListDiv">
                { <TopBar
                    AddButton={BranchDisabled ? true : false}
                    SearchInput={true}
                    Tittle={''}
                    branchUser={true}
                    AddButtonName={'Add Branch User'}
                    showAddButtonalways={true}
                    SearchValue={!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || ''}
                    handleOnClickSearch={handleSearchParams}
                    handleSidePopupClick={handleSidePopupClick}
                    BranchDisabled={BranchDisabled}
                    status={searchParams.get('status')!=null?(searchParams.get('status')==='true'?"active":"inactive"):null}
                    handleFilters ={handleFilters}
                    isClick={`/manage-branches/${id}/add-branch-user`}
                    customSearchPlaceHolder={placeholderOptions[placeholderIndex]}
                    statusBarList={['Active','Inactive']}
                />}
                {loading ? <ItemShimmer classkey={'mt-2.5 px-1'}/>
                    : <>
                        <Table
                            branchName={branchName}
                            pageNumber={Number(searchParams.get('page_number')) || 1}
                            handleOnClickSort={handleSearchParams}
                            sortValue={searchParams.get('sort') || ''}
                            setConfirmationState={setConfirmationState}
                            email={email}
                            BranchDisabled={BranchDisabled}
                            searchParams={searchParams}
                            openViewPopup={openViewPopup}
                            setOpenViewPopup={setOpenViewPopup}
                            handleSidePopupClick={handleSidePopupClick}
                        />
                        {(List.total_count > 10) && <Pagination
                            totalPageNumber={Math.ceil(List.total_count / 10)}
                            selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                            handleOnClickPageNumber={handleOnClickPageNumber}
                        />}
                    </> 
                }
            </div>
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} Branch User`} `}
                        message = {`Are you sure you want to ${confirmationState.status === 'Reset Password' ? `${confirmationState.status} for ${confirmationState.item.first_name} ${confirmationState.item.last_name} ?` : `${confirmationState.status} ${confirmationState.item.first_name} ${confirmationState.item.last_name} ?`}`}
                        buttonName = {confirmationState.status}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }
            {openViewPopup && 
                <ViewBranchUser
                    selectedbranchUserEmail={selectedbranchUserEmail}
                    handleSidePopupClick={handleSidePopupClick}
                    openViewPopup={openViewPopup}
                    setOpenViewPopup={setOpenViewPopup}
                    branchUserData={branchUserData}
                    setbranchUserData={setbranchUserData}
                    listOfRoles={listOfRoles}
                    loadingPage={loadingPage}
                    heading={'View Branch User'}
                    enableEdit={true}
                />
            }
        </>
    );
}

export default ManageBranchUserList;
